import { MenuLinkWithSubmenuDesktop } from "./MenuLinkWithSubmenuDesktop";
import { MenuLinkWithSubmenuMobile } from "./MenuLinkWithSubmenuMobile";

export { MenuLinkWithSubmenuDesktop, MenuLinkWithSubmenuMobile };
